<ng-container *ngIf="subjectForm && !subjectForm.disabled">
    <app-basic-card>
        <app-basic-form [form]="subjectForm" [keys]="subjectFormKeys"></app-basic-form>
        <button mat-raised-button color="primary" (click)="onSearchClick()" [disabled]="!subjectForm.valid">{{'ricerca' | uppercase}}</button>
        <button mat-button color="warn" class="mx-3" (click)="reset()">{{'reset' | uppercase}}</button>
    </app-basic-card>
</ng-container>
<div class="pt-3" *ngIf="searchedSubject">
    <div class="pt-3">
        <h6 class="card-header-label" style="padding-left: 1em;">Soggetto ricercato</h6>
        <app-policy-card [item]="searchedSubject" [title]="subjectName" [keys]="subjectKeys" [tooltip]="'Nuovo contraente'">
        </app-policy-card>
    </div>
    <div class="pt-4">
        <h6 class="card-header-label" style="padding-left: 1em;">Inserire le seguenti informazioni:</h6>
        <app-basic-form [form]="form" [keys]="formKeys"></app-basic-form>
    </div>
    <div class="pb-4" *ngIf="!hideAddressSection">
        <h6 class="card-header-label" style="padding-left: 1em;">Informazioni di recapito:</h6>
        <app-address-change 
            [form]="addressForm" 
            [isReadOnly]="isReadOnly"
            [countriesList]="countriesList" 
            [provincesList]="provincesList"
            [citiesList]="citiesList">
        </app-address-change>
    </div>
</div>